"use client";

import { FaMapMarkerAlt } from "react-icons/fa";
import cn from "classnames";

import { facilities } from "@/data/facilities";

const activeFacilities = facilities.filter((f) => f.status === "active");

/** Segmented selector for choosing which VD Motor facility an action targets. */
const FacilityPicker = ({
	value,
	onChange,
	label = "Välj anläggning",
}: {
	value: string;
	onChange: (slug: string) => void;
	label?: string;
}) => {
	return (
		<div>
			<p className="text-xs text-gray-500 uppercase tracking-wide mb-3">{label}</p>
			<div className="grid grid-cols-2 gap-3">
				{activeFacilities.map((f) => {
					const selected = f.slug === value;
					return (
						<button
							key={f.slug}
							type="button"
							onClick={() => onChange(f.slug)}
							aria-pressed={selected}
							className={cn(
								"flex items-center gap-3 rounded-lg border px-4 py-3 text-left transition-colors cursor-pointer",
								selected
									? "border-accent bg-accent/10 text-white"
									: "border-white/10 bg-white/[0.03] text-gray-300 hover:border-white/20 hover:text-white"
							)}
						>
							<span
								className={cn(
									"rounded-md p-2 flex items-center shrink-0",
									selected ? "bg-accent/20" : "bg-white/[0.06]"
								)}
							>
								<FaMapMarkerAlt className={selected ? "text-accent" : "text-gray-400"} size={16} />
							</span>
							<span className="text-sm font-semibold">{f.name}</span>
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default FacilityPicker;
